







import 'reflect-metadata'
import { Vue, Component } from 'vue-property-decorator'
import Web3 from 'web3'
import { DEFAULT_NETWORK } from '@/store/modules/network/network'
import { toDCM } from '@/helper'

@Component({
    components: {},
    filters: { toDCM },
})
export default class Gas extends Vue {
    web3: any = null
    ethGasPrice = '0'

    created() {
        const ethEP = DEFAULT_NETWORK.dcommGoEthUrl
        this.web3 = new Web3(ethEP)
    }

    mounted() {
        this.web3.eth
            .getGasPrice()
            .then((res: string) => (this.ethGasPrice = res))
    }

    get prices(): any {
        return this.$store.state.prices
    }

    get inUSD() {
        const usd: number = this.prices?.usd
        return toDCM(parseInt(this.ethGasPrice) * usd, 18).toFixed(9)
    }

    get gasPrice() {
        return toDCM(this.ethGasPrice, 9).toFixed(2)
    }
}
